import { getMappedEvents } from '../utils/getMappedEvents';

// Trial Lead Survey funnel; trial-context events ride the GA mirror (see trackEvent → mirrorTrialFunnelEvent).
const EVENTS = [
  'leadSurveyShown',
  'leadSurveyHoursSelected',
  'leadSurveyLanguagesSelected',
  'leadSurveyContinueClicked',
  'leadSurveySubmitted',
  'leadSurveyQualified',
  'bookACallOpened',
  'bookACallBooked',
  'bookACallSkipped',
  'bookACallMaybeLaterClicked',
  'bookACallCloseClicked',
  'bookACallEmbedFailed',
  'bookADemoBannerShown',
  'bookADemoBannerCtaClick',
  'bookADemoHeaderClick',
] as const;

export const leadSurveyEvents = getMappedEvents([...EVENTS], {
  shouldSendSubscriptionData: true,
});
